import { SortDirectionEnum } from '../../..';

export class PageOptionsRequestDto {
  sortDirection: SortDirectionEnum;
  sortColumn: any;
}
